export const gridStyles = (theme) => ({
  root: {
    flexBasis: 'auto',
  }
});

export default gridStyles;
